export function shorten(text: string, maxChars: number = 50) {
  return {
    shortened:
      text.length > maxChars + 4
        ? text.substr(0, maxChars).concat(' ...')
        : text,
    full: text,
  };
}

export function strSlug(text: string): string {
  const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';
  const b = 'aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

export function replaceWhitespaces(text: string): string {
  return text.split(' ').join('_');
}



// WEBPACK FOOTER //
// ./src/utils/string.ts